"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Accreditations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const logos = [{
    name: "James Hardie",
    svg: <svg viewBox="0 0 140 32" xmlns="http://www.w3.org/2000/svg" className="h-8 w-auto" fill="currentColor" aria-label="James Hardie">
          <path d="M8 6h6l5 14 5-14h6L20 28h-2L8 6z" />
          <text x="36" y="22" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="16" letterSpacing="-0.5">HARDIE</text>
        </svg>
  }, {
    name: "LP SmartSide",
    svg: <svg viewBox="0 0 160 32" xmlns="http://www.w3.org/2000/svg" className="h-8 w-auto" fill="currentColor" aria-label="LP SmartSide">
          <rect x="6" y="6" width="20" height="20" stroke="currentColor" strokeWidth="2.5" fill="none" />
          <path d="M10 22 L22 10" stroke="currentColor" strokeWidth="2.5" />
          <text x="34" y="22" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="16" letterSpacing="-0.5">SMARTSIDE</text>
        </svg>
  }, {
    name: "Lux Panels",
    svg: <svg viewBox="0 0 150 32" xmlns="http://www.w3.org/2000/svg" className="h-8 w-auto" fill="currentColor" aria-label="Lux Panels">
          <circle cx="16" cy="16" r="10" stroke="currentColor" strokeWidth="2.5" fill="none" />
          <circle cx="16" cy="16" r="3" />
          <text x="34" y="22" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="16" letterSpacing="-0.5">LUX PANELS</text>
        </svg>
  }, {
    name: "Metal Roofing",
    svg: <svg viewBox="0 0 110 32" xmlns="http://www.w3.org/2000/svg" className="h-8 w-auto" fill="currentColor" aria-label="Metal Roofing">
          <path d="M8 26 C 12 6, 24 6, 28 26" stroke="currentColor" strokeWidth="2.5" fill="none" />
          <path d="M8 6 C 12 26, 24 26, 28 6" stroke="currentColor" strokeWidth="2.5" fill="none" />
          <text x="36" y="22" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="16" letterSpacing="-0.5">METAL</text>
        </svg>
  }, {
    name: "Stone Veneer",
    svg: <svg viewBox="0 0 140 32" xmlns="http://www.w3.org/2000/svg" className="h-8 w-auto" fill="currentColor" aria-label="Stone Veneer">
          <rect x="6" y="6" width="6" height="20" />
          <rect x="16" y="12" width="6" height="14" />
          <rect x="26" y="18" width="6" height="8" />
          <text x="40" y="22" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="16" letterSpacing="-0.5">STONE</text>
        </svg>
  }, {
    name: "ACM Panels",
    svg: <svg viewBox="0 0 160 32" xmlns="http://www.w3.org/2000/svg" className="h-8 w-auto" fill="currentColor" aria-label="ACM Panels">
          <polygon points="16,4 28,16 16,28 4,16" stroke="currentColor" strokeWidth="2.5" fill="none" />
          <polygon points="16,11 21,16 16,21 11,16" />
          <text x="36" y="22" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="16" letterSpacing="-0.5">ACM PANELS</text>
        </svg>
  }];
  return <section data-section-id="9519" id="industry-accreditations" className="bg-background text-foreground ![padding:50px_24px_50px_24px]">
      <div ref={ref} className="mx-auto max-w-[1200px] border border-border rounded-md px-6 py-8 md:px-10 md:py-12 transition-all duration-[600ms] ease-out" style={{
      opacity: isVisible ? 1 : 0
    }}>
        <div className="mb-8 text-center">
          <p className="font-default text-xs md:text-sm font-bold uppercase text-primary" style={{
          letterSpacing: "0.2em"
        }}>Brands &amp; Materials We Work With</p>
        </div>

        <div className="h-px w-full bg-border mb-8" />

        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-8 md:gap-x-14">
          {logos.map((logo, i) => <div key={logo.name} data-index={i} className="text-foreground opacity-60 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              {logo.svg}
            </div>)}
        </div>
      </div>
    </section>;
}